import { useImperativeHandle, useState } from 'react'

import { DraggableModal } from '../DraggableModal'

import { PreviewFileProps, PreviewItem } from './interface'

export const PreviewAudio = ({ ref }: PreviewFileProps) => {
  const [file, setFile] = useState<PreviewItem>()

  useImperativeHandle(ref, () => {
    return {
      open(file) {
        setFile(file)
      }
    }
  })

  return (
    <DraggableModal
      centered
      destroyOnHidden
      footer={null}
      open={!!file}
      title={file?.name}
      mask={{
        closable: false
      }}
      onCancel={() => setFile(undefined)}
    >
      <audio autoPlay controls muted src={file?.url}>
        <track kind='captions' />
      </audio>
    </DraggableModal>
  )
}
